import React, { useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import imageCompression from 'browser-image-compression';
import SelectInputs from 'src/components/inputs/SelectInputs';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import ReactSelect from 'react-select';

const CustomTimeSlotSelector = ({ title, name, value, handleChange, required, fieldValidation, startTime = 9 }) => {
  const generateTimeOptions = () => {
    const options = [];
    for (let hour = startTime; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 10) {
        let hours12 = hour % 12 || 12;
        let period = hour < 12 ? 'AM' : 'PM';
        let time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
        let label = `${String(hours12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${period}`;
        options.push({ value: time, label: label });
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '3.3rem',
      fontSize: '1rem',
      borderColor: state.isFocused ? '#6174DD' : '#ccc',
      boxShadow: state.isFocused ? '0 0 0 1px #6174DD' : null,
      '&:hover': {
        borderColor: state.isFocused ? '#6174DD' : '#ccc'
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '1rem'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#6174DD' : state.isFocused ? '#E0E7FF' : 'white',
      color: state.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: '#6174DD',
        color: 'white'
      }
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black'
    })
  };

  const formatTimeTo24hr = (selectedTime) => {
    const [time, period] = selectedTime.split(' ');
    let [hours, minutes] = time.split(':');
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10);

    if (period === 'PM' && hours !== 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };

  const handleChangeSelect = (selectedOption) => {
    const formattedTime = selectedOption ? formatTimeTo24hr(selectedOption.label) : '';
    handleChange({ target: { name, value: formattedTime } });
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      <Typography variant="subtitle1" fontWeight={600} component="label" htmlFor={name} mb="5px">
        {title} {required !== false && <ReqField />}
      </Typography>
      <ReactSelect
        options={timeOptions}
        value={timeOptions.find(option => option.value === value)}
        onChange={handleChangeSelect}
        isClearable
        styles={customStyles}
      />
      {fieldValidation && (
        <div style={{ color: 'red', fontSize: '0.875rem', marginTop: '0.25rem' }}>
          This field is required
        </div>
      )}
    </div>
  );
};

const activeDurationTypeMenuOptions = [
  { placeholder: 'Days', value: 'Days' },
  { placeholder: 'Months', value: 'Months' },
];
const initialValue = {
  name: '',
  email: '',
  phone: '',
  address: '',
  brandName: '',
  // branchName: '',
  images: '',
  link: '',
  activeDuration: 0,
  activeDurationType: 'Months',
  gstNumber: '',
  confirmGstNumber: '',
  salonOpeningTime: '',
  salonClosingTime: '',
};

const AddOwner = () => {
  const { createOwner, setShowMessage } = useMain();

  const [formData, setFormData] = useState(initialValue);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  console.log(formData);

  const handleImage = async (e) => {
    const imageFile = e.target?.files[0];

    if (imageFile) {
      const maxSizeInBytes = 1024 * 1024; // 1MB
      const currentSizeInBytes = imageFile.size;

      if (currentSizeInBytes <= maxSizeInBytes) {
        // If the image is already smaller than 1MB, no need to compress
        setFormData({ ...formData, [e.target.name]: imageFile });
      } else {
        // Image needs compression
        try {
          const options = {
            maxSizeMB: 1,
            useWebWorker: true,
          };
          const compressedImage = await imageCompression(imageFile, options);
          setFormData({ ...formData, [e.target.name]: compressedImage });
        } catch (error) {
          setShowMessage({
            message: 'Error compressing image. Please try again.',
            messageType: 'error',
          });
        }
      }
    }
  };

  const handleSubmit = async () => {
    const {
      name,
      email,
      phone,
      address,
      // branchName,
      brandName,
      images,
      link,
      activeDuration,
      activeDurationType,
      gstNumber,
      confirmGstNumber,
      salonOpeningTime,
      salonClosingTime,
    } = formData;
    if (name.trim() === '')
      return setShowMessage({ message: 'Owner Name is Required', messageType: 'error' });
    if (phone === '' || phone.length !== 10)
      return setShowMessage({ message: 'Owner Number is Required', messageType: 'error' });
    if (email === '') return setShowMessage({ message: 'Email is Required', messageType: 'error' });
    // if (branchName === '')
    //   return setShowMessage({ message: 'Branch Name is Required', messageType: 'error' });

    // if (brandName === '')
    //   return setShowMessage({ message: 'Brand Name is Required', messageType: 'error' });
    if (address === '')
      return setShowMessage({ message: 'Address is required', messageType: 'error' });
    if (activeDuration == 0 || activeDuration < 0)
      return setShowMessage({
        message: 'activeDuration is required or greater than 0',
        messageType: 'error',
      });

    // if (images === '') {
    //   return setShowMessage({ message: 'Owner Photo is Required', messageType: 'error' });
    // }
    // if (link === '') return setShowMessage({ message: 'Link is Required', messageType: 'error' });

    const formDataUpdated = new FormData();
    formDataUpdated.append('name', name);
    formDataUpdated.append('phone', phone);
    formDataUpdated.append('email', email);
    formDataUpdated.append('brandName', brandName);
    // formDataUpdated.append('branchName', branchName);
    formDataUpdated.append('address', address);
    formDataUpdated.append('activeDuration', activeDuration);
    formDataUpdated.append('activeDurationType', activeDurationType);
    formDataUpdated.append('images', images);
    formDataUpdated.append('link', link);
    formDataUpdated.append('gstNumber', gstNumber);
    formDataUpdated.append('confirmGstNumber', confirmGstNumber);
    formDataUpdated.append('salonOpeningTime', salonOpeningTime);
    formDataUpdated.append('salonClosingTime', salonClosingTime);

    try {
      setLoading(true);
      const res = await createOwner(formDataUpdated);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Owner created successfully',
          messageType: 'success',
        });
        setFormData((pre) => ({ ...pre, ...initialValue }));
      } else {
        setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer title="Add Owner" description="this is add Owner">
      <DashboardCard title="Add Owner">
        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Name'}
                name={'name'}
                value={formData?.name}
                handleChange={handleChange}
                type={'text'}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Contact Number'}
                name={'phone'}
                value={formData?.phone}
                handleChange={handleChange}
                type={'number'}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Email Address'}
                name={'email'}
                value={formData?.email}
                handleChange={handleChange}
                type={'email'}
              />
            </Grid>
          </Grid>
        </Box>

        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextInputs
                required={true}
                title={'Brand Name'}
                name={'brandName'}
                value={formData?.brandName}
                handleChange={handleChange}
                type={'text'}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Address'}
                name={'address'}
                value={formData?.address}
                handleChange={handleChange}
                type={'text'}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextInputs
                required={false}
                title="Gst Number"
                name="gstNumber"
                value={formData.gstNumber}
                handleChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextInputs
                required={false}
                title="Confirm Gst Number"
                name="confirmGstNumber"
                value={formData.confirmGstNumber}
                handleChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextInputs
                    title={'Active Duration'}
                    name={'activeDuration'}
                    placeholder="0"
                    min={0}
                    value={formData?.activeDuration}
                    handleChange={handleChange}
                    type={'number'}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SelectInputs
                    title={'Active Duration Type'}
                    name={'activeDurationType'}
                    value={formData?.activeDurationType}
                    handleChange={handleChange}
                    options={activeDurationTypeMenuOptions}
                    optionTitle={'placeholder'}
                    optionValue={'value'}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Upload Photo (max size: 1MB)'}
                name={'images'}
                value={formData?.images || ' '}
                handleChange={handleImage}
                type={'file'}
                required={false}
              />
            </Grid>
          </Grid>
        </Box>

        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <CustomTimeSlotSelector
                title="Salon Opening Time"
                name="salonOpeningTime"
                value={formData.salonOpeningTime}
                handleChange={handleChange}
                startTime={6}
                required={false}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <CustomTimeSlotSelector
                title="Salon Closing Time"
                name="salonClosingTime"
                value={formData.salonClosingTime}
                handleChange={handleChange}
                startTime={9}
                required={false}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Add Link'}
                name={'link'}
                value={formData?.link}
                handleChange={handleChange}
                type={'text'}
                required={false}
              />
            </Grid>
          </Grid>
        </Box>

        <div style={{ width: '200px', margin: '3rem auto' }}>
          {loading ? (
            <ShowLoader />
          ) : (
            <Button
              variant="contained"
              fullWidth
              color="primary"
              target="_blank"
              sx={{
                background: '#6174DD',
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          )}
        </div>
      </DashboardCard>
    </PageContainer>
  );
};

export default AddOwner;
